import React from "react";
import Wrapper from "../Wrapper";
import { Link } from "react-router-dom";
import axios from "axios";
import { Post } from "../../classes/post";
import Paginator from "../components/Paginator";
import Deleter from "../components/Deleter";
import { connect } from "react-redux";
import { User } from "../../classes/user";
import { toast } from "react-hot-toast";
import Switches from "../components/ui/switches";
import Search from "../components/Search";
import { convertImageURL } from "../../libs/image";

const Posts = (props: { user: User }) => {
  const [posts, setPosts] = React.useState([]);
  const [lastPage, setLastPage] = React.useState(0);
  const page = 1;
  const SEARCH_ENDPOINT = "posts";

  React.useEffect(() => {
    (async () => {
      // const response = await axios.get(`posts?page=${page}`);

      // setPosts(response.data.data);
      // setLastPage(response.data.meta.last_page);

      await axios
        .get(`posts?page=${page}`)
        .then((response) => {
          setPosts(response.data.data);
          setLastPage(response.data.meta.last_page);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response.data.error);
        });
    })();
  }, []);

  const handleDelete = async (id: number) => {
    setPosts(posts.filter((p: Post) => p.id !== id));
  };

  const handlePageChange = async (page: number) => {
    // const response = await axios.get(`posts?page=${page}`);

    // setPosts(response.data.data);

    await axios
      .get(`posts?page=${page}`)
      .then((response) => {
        setPosts(response.data.data);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.error);
      });
  };

  const actions = (id: number) => {
    if (props.user.canEdit("posts")) {
      return (
        <div className="btn-group mr-2">
          <Link
            to={`/posts/${id}/edit`}
            className="btn btn-sm btn-outline-secondary"
          >
            Edit
          </Link>
          <Deleter id={id} endpoint={"posts"} handleDelete={handleDelete} />
        </div>
      );
    }
  };

  const onChangeActive = (e: any) => {
    const dataid = e.target.getAttribute("data-dataid");

    // const id = e.target.id;
    const id = dataid;
    const checked = e.target.checked;

    axios
      .put(`/posts/${id}`, {
        is_active: checked,
      })
      .then((response) => {
        toast.success("Post updated successfully");
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.error);
      });
  };

  let addButton = null;

  if (props.user.canEdit("posts")) {
    addButton = (
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <div className="btn-toolbar mb-2 mb-md-0">
          <Link
            to={"/posts/create"}
            className="btn btn-sm btn-outline-secondary"
          >
            Add
          </Link>
        </div>
      </div>
    );
  }

  return (
    <Wrapper>
      <div className="float-left">{addButton}</div>
      <div className="float-right mt-3">
        <Search endpoint={SEARCH_ENDPOINT} setData={setPosts} />
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-sm">
          <thead>
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Title</th>
              <th>Description</th>
              <th>Slug</th>
              <th>Active</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {posts.map((post: Post) => {
              return (
                <tr key={post.id}>
                  <td>{post.id}</td>
                  <td>
                    <img
                      alt=""
                      src={convertImageURL(post.image)}
                      width="50"
                    />
                  </td>
                  <td>{post.title}</td>
                  <td>{post.description}</td>
                  <td>{post.slug}</td>
                  <td>
                    <Switches
                      id={`active-${post.id}`}
                      dataid={post.id}
                      active={post.is_active}
                      handleChange={onChangeActive}
                    />
                  </td>

                  <td>{actions(post.id)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Paginator lastPage={lastPage} handlePageChange={handlePageChange} />
    </Wrapper>
  );
};

// @ts-ignore
export default connect((state) => ({ user: state.user }))(Posts);
